interface RoomSelectionLike {
  spaceId?: string | null;
}

interface EventRoomSelectionLike extends RoomSelectionLike {
  spaces?: RoomSelectionLike[] | null;
}

const getRoomIds = (spaces: RoomSelectionLike[]): string[] =>
  spaces
    .map((space) => space.spaceId)
    .filter((spaceId): spaceId is string => Boolean(spaceId))
    .sort();

export const haveSelectedRoomsChanged = (
  event: EventRoomSelectionLike | undefined,
  selectedSpaces: RoomSelectionLike[]
): boolean => {
  if (!event) return false;

  const originalRoomIds = getRoomIds(event.spaces ?? []);
  if (originalRoomIds.length === 0 && event.spaceId) {
    originalRoomIds.push(event.spaceId);
  }

  const editedRoomIds = getRoomIds(selectedSpaces);
  return (
    editedRoomIds.length !== originalRoomIds.length ||
    editedRoomIds.some((spaceId, index) => spaceId !== originalRoomIds[index])
  );
};